import { API } from "@/main";

const state = {
  token: localStorage.getItem("auth_token"),
  company: localStorage.getItem("company_name"),
  companies: [],
  loggingIn: false,
  loginError: null
};

const getters = {
  isAuthenticated: state => !!state.token,
  hasToken: state => !!state.token,
  // hasCompany: state => !!state.company,
  // companies: state => state.companies,
  loggingIn: state => state.loggingIn,
  loginError: state => state.loginError
};

const mutations = {
  LOGIN_START: state => {
    state.loggingIn = true;
  },

  LOGIN_SUCCESS: (state, resp) => {
    state.token = resp;
    state.loggingIn = false;
  },

  LOGIN_ERROR: (state, error) => {
    state.token = "";
    // state.hasCompany = ''
    state.loggingIn = false;
    state.loginError = error;
  },

  UPDATE_CURRENT_COMPANY: (state, company) => {
    state.company = company;
  },

  UPDATE_USER_COMPANIES: (state, companies) => {
    state.companies = companies;
  },

  LOGOUT: state => {
    state.token = "";
    state.company = "";
    state.companies = [];
  }
};

const actions = {
  LOGIN_REQUEST: ({ commit, dispatch }, data) => {
    commit("LOGIN_START");
    return new Promise((resolve, reject) => {
      API.auth.login(
        data,
        result => {
          let token = result.data.token;
          localStorage.setItem("auth_token", token);
          commit("LOGIN_SUCCESS", token);
          dispatch("fetchUserDetails");
          resolve(result);
        },
        error => {
          commit("LOGIN_ERROR", error);
          reject(error);
        }
      );
    });
  },

  GET_USER_COMPANIES: ({ commit }) => {
    return new Promise((resolve, reject) => {
      resolve([1]);
    });
  },

  PICK_COMPANY: ({ commit, dispatch }, company) => {
    let finalParent = company.final_parent;
    localStorage.setItem("company_name", company.name);
    localStorage.setItem("company_uuid", company.uuid);
    localStorage.setItem("company_id", company.id);
    localStorage.setItem("company_type", company.type);
    localStorage.setItem("2fa_required", company["2fa_required"]);
    localStorage.setItem("final_company_name", finalParent ? finalParent.name : '');
    localStorage.setItem("final_company_uuid", finalParent ? finalParent.uuid : '');
    localStorage.setItem("final_company_id", finalParent ? finalParent.id : '');
    commit("UPDATE_CURRENT_COMPANY", company.name);
    dispatch("fetchUserDetails");
  },

  CHANGE_COMPANY: ({ commit, dispatch }) => {
    dispatch("clearCompany");
    dispatch("clearWorkspace");
    dispatch("RESET_HOME_STORE_MODULE_STATE");
    commit("UPDATE_USER_COMPANIES", []);
    commit("UPDATE_CURRENT_COMPANY", "");
  },

  LOGOUT({ commit, dispatch }) {
    localStorage.removeItem("auth_token");
    sessionStorage.removeItem("active_layers");
    sessionStorage.removeItem("network_active_layers");
    sessionStorage.removeItem("active_layer_map");
    sessionStorage.removeItem("active_network_layer_map");
    sessionStorage.removeItem("network_expanded_layer_levels");
    sessionStorage.removeItem("expanded_layer_levels");
    sessionStorage.removeItem("expanded_map_layer_levels");
    sessionStorage.removeItem("active_geoserver_labels");
    dispatch("clearCompany");
    dispatch("clearUserDetails");
    dispatch("clearWorkspace");
    dispatch("clearUserPermissions");
    dispatch("RESET_HOME_STORE_MODULE_STATE");
    commit("LOGOUT");
    new Promise((resolve, reject) => { 
      API.auth.logout(
      result => {
        resolve(result);
      },
      error => {
        reject(error);
      }
    )});
  
  },

  CANCEL_LOGIN({ commit, dispatch }) {
    localStorage.removeItem("auth_token");
    dispatch("clearUserDetails");
    dispatch("RESET_HOME_STORE_MODULE_STATE");
    commit("LOGOUT");
  },

  clearCompany() {
    localStorage.removeItem("company_name");
    localStorage.removeItem("company_uuid");
    localStorage.removeItem("company_id");
    localStorage.removeItem("2fa_required");
    localStorage.removeItem("company_type");
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/auth.js